/* eslint-disable default-case */
import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Button,
    message,
    Typography,
    Tabs,
    MainModal,
    Form,
    Tag,
    Modal
} from "../../ui/ot"
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";
import { Book, Loader2, Trash2, User, Edit, Edit2, RefreshCw, CalendarDays, ArrowUp, ArrowDown } from "lucide-react"
// import { Button } from "../../ui/button"
import { Input } from "../../ui/input"
import { Label } from "../../ui/label"
import { Badge } from "../../ui/badge"
import dayjs from 'dayjs'
import BorrowedBooks from "./borrowed_books";
import CheckoutForm from "./checkout_form";
import { useSearchParams } from "react-router-dom";
import StaffPatronModal from "./staff_patron_modal";
import StaffPatron from "./staff_patron";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../ui/card"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../ui/table"

const BorrowWorkflow = ({
    keyPrefix = "library.backstage.borrow",
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const ref = useRef(null)
    const [form] = Form.useForm();
    const [staff_form] = Form.useForm();
    const [searchParams, setSearchParams] = useSearchParams();
    const cardnumber = searchParams.get('cardnumber');
    const [scanMode, setScanMode] = useState("manual")
    const [scanTarget, setScanTarget] = useState("reader")
    const [isScanning, setIsScanning] = useState(false)
    const [manualCode, setManualCode] = useState(cardnumber ? cardnumber : null)
    const [scannedBooks, setScannedBooks] = useState([])
    const [item, setItem] = useState(null)
    const [borrower, setBorrower] = useState(null)
    const [scanFocus, setScanFocus] = useState(null)
    const [loading, setLoading] = useState(false)
    const [modalOpen, setModalOpen] = useState(false)
    const [open, setOpen] = useState(false)
    const [searchStaffModalOpen, setSearchStaffModalOpen] = useState(false)
    const [staffLoading, setStaffLoading] = useState(false)
    const [selectStaffInfo, setSelectStaffInfo] = useState([])

    // Focus the hidden input when component mounts or when scan target changes
    const handleScanFocus = (input) => {
        ref.current.focus()
    }
    // 掃描 Simulate scanning a book with the button (for demo purposes)
    const handleSimulateScan = (e) => {
        if (e.key === "Enter") {
            if (!!manualCode) {
                if (scanTarget === "reader") {
                    //尋找讀者
                    BorrowerController.getData({
                        cardnumber: manualCode
                    }).then((response) => {
                        let data = response?.data
                        let dataFirst = data?.find((e) => true)
                        if (!!dataFirst) {
                            setBorrower(dataFirst)
                            setManualCode('')
                            setScanTarget("book")
                        }
                        else {
                            setBorrower(dataFirst)
                            message.error(t('reader_not_found'))
                        }
                    })
                } else {
                    // Book 掃描
                    //判斷是否重複掃描
                    if (scannedBooks?.find((ele) => ele?.item_barcode === manualCode)) {
                        message.error(t('book_already_scanned'))
                        return
                    }
                    ItemController.getData({
                        barcode: manualCode
                    }).then((response) => {
                        let data = response?.data
                        let dataFirst = data?.find((e) => true)
                        if (!!dataFirst) {
                            setScannedBooks((prev) => [{ ...dataFirst }, ...prev])
                            setItem(dataFirst)
                            setManualCode('')
                        }
                        else {
                            message.error(t('item_not_found'))
                        }
                    })
                }
            }
        }
    }

    const handleRemoveBook = (item_itemnumber) => {

        setScannedBooks((prev) => prev.filter((book) => book?.item_itemnumber !== item_itemnumber))
    }
    const handleChangeScanTarget = (target) => {
        setScanTarget(target)
        // Focus the hidden input after changing target
        if (scanFocus) {
            setTimeout(() => scanFocus.focus(), 100)
        }
    }
    const getBookStatusBadge = (availability) => {
        switch (availability) {
            case "available":
                return (
                    <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
                        {t('available')}
                    </Badge>
                )
            case "reference-only":
                return (
                    <Badge variant="outline" className="bg-amber-50 text-amber-700 border-amber-200">
                        {t('reference_only')}
                    </Badge>
                )
            case "checked-out":
                return (
                    <Badge variant="outline" className="bg-red-50 text-red-700 border-red-200">
                        {t('checked_out')}
                    </Badge>
                )
            case "not_for_loan":
                return (
                    <Badge variant="outline" className="bg-red-50 text-red-700 border-red-200">
                        {t('not_for_loan')}
                    </Badge>
                )
        }
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));

            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
            }
        }
        if (axiosMode === "get") {
            setIsScanning(false)
        }
    };
    const onCheckoutBefore = ({ axiosMode, status, values }) => {
        if (axiosMode === "post") {
            setLoading(true)
        }
        // propsOnBefore({ axiosMode, status, values })
        // setModalLoading(true)
    }
    const onCheckoutFinish = ({ axiosMode, status, values }) => {
        // propsOnFinish({ axiosMode, status, values })
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('borrow_success'))
                let data = values?.data
                let firstData = data.find((ele) => true)
                let result = firstData?.result
                let note = firstData?.note

                setScannedBooks((prev) => {
                    return prev?.map((val, index) => {
                        if (index === 0) {
                            return {
                                ...val,
                                ...result,
                                issue_id: result?.checkout_id,
                                note,
                                due_date: dayjs(result?.due_date).format("YYYY-MM-DD HH:mm"),
                                borrow_result: 'success',
                            }
                        }
                        else {
                            return {
                                ...val
                            }
                        }
                    })
                })

            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                setModalOpen(false)
            }
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                // message.error("新增失敗")
                setScannedBooks((prev) => {
                    return prev?.map((val, index) => {
                        if (index === 0) {
                            return {
                                ...val,
                                borrow_result: 'error'
                            }
                        }
                        else {
                            return {
                                ...val
                            }
                        }
                    })
                })
                if (values === "Confirmation error") {
                    if (item?.reserve.length > 0) {
                        message.error(t('item_reserved_or_borrowed'))
                    }
                    else message.error(t('borrow_limit_reached'))
                }
                else if (values === "Checkout not authorized (NO_MORE_RENEWALS)") {
                    message.error(t('already_borrowed_and_not_renewable'))
                }
                else if (values === "Checkout not authorized (EXPIRED)") {
                    message.error(t('account_expired'))
                }
                else if (values === "Expected integer - got string.") {
                    message.error("請輸入數字")
                }
                else {
                    if (values?.message) {
                        message.error(values?.message)

                    }
                    else {
                        message.error("借閱失敗")

                    }
                }
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                setModalOpen(false)
            }
        }
        setLoading(false)

    }
    const handleClean = () => {
        setBorrower(null)
        setItem(null)
        setManualCode(null)
        setScannedBooks([])
        setScanTarget("reader")
    }
    const onFormFinish = (value) => {
        CheckoutController.patchData([
            {
                note: value?.note || "",
                issue_id: value?.issue_id
            }
        ])
    }
    const BorrowerController = useCRUDController({
        apiRoute: "/library/koha/borrower",
        onBefore: ({ axiosMode, status }) => {
            setIsScanning(true)
        },
        onFinish: onFinish
    })
    const StaffPatronController = useCRUDController({
        apiRoute: "/library/organization_structure/api/staff/concatenation",
    })
    const ItemController = useCRUDController({
        apiRoute: "/koha/item",
        onBefore: ({ axiosMode, status }) => {
            setIsScanning(true)
        },
        onFinish: onFinish
    })
    const CheckoutController = useCRUDController({
        apiRoute: "/library/koha/checkout",
        onBefore: onCheckoutBefore,
        onFinish: onCheckoutFinish,
    })
    // useEffect(() => {
    //     if (scanMode === "barcode" && !!manualCode) {
    //         handleSimulateScan()
    //     }
    // }, [manualCode])
    useEffect(() => {
        if (!!item) {
            CheckoutController.postData([
                {
                    borrowernumber: borrower?.borrowernumber,
                    itemnumber: item?.item_itemnumber,
                    biblionumber: item?.bib_biblionumber,
                    note: item?.item_internal_notes || ""
                }
            ])
        }
        handleScanFocus()
    }, [item])
    useEffect(() => {
        handleScanFocus()
    }, [scanMode, manualCode])
    return (<Row gutter={[16, 0]}>

        <Col>
            <MainModal
                axiosMode={'patch'}
                propsForm={form}
                propsOpen={modalOpen}
                propsSetOpen={setModalOpen}
                onFinish={onFormFinish}
                width={600}
                formElement={<CheckoutForm />}
                keyPrefix={keyPrefix}
            />
        </Col>
        <Col>
            <Modal
                width={1600}
                open={searchStaffModalOpen}
                okText="確認"
                cancelText="關閉"
                onCancel={() => {
                    setSearchStaffModalOpen(false)
                }}
                onOk={() => {
                    setSearchStaffModalOpen(false)
                    setManualCode(selectStaffInfo?.cardnumber)
                }}
            >
                <Row>
                    <Col span={24}>
                        <StaffPatron
                            propsRowSelectionType="radio"
                            readonly={true}
                            onSelect={(selectedRowsInfo, selectedRowKeys) => {
                                let dataFirst = selectedRowsInfo?.find((ele) => true)
                                setSelectStaffInfo(dataFirst)
                            }}
                        />
                    </Col>
                </Row>
            </Modal>
        </Col>
        <Col span={24}>
            <Typography.Title level={3}>{t('scan_borrow_books')}</Typography.Title>
            <Typography.P>{t('scan_instruction')}</Typography.P>
            <div className="space-y-6">
                {/* <Tabs
                    activeKey={scanMode}
                    className="w-full"
                    onChange={(value) => {
                        setScanMode(value)
                    }}
                    items={[
                        {
                            key: 'barcode',
                            tab: t('barcode_scan')
                        },
                        {
                            key: 'manual',
                            tab: t('manual_input')
                        },
                    ]}
                /> */}
                <Row gutter={[16, 32]}>
                    <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                        {/* <input
                            type="text"
                            // className="sr-only"
                            onKeyDown={handleBarcodeScan}
                            ref={handleScanFocus} autoFocus
                        /> */}
                        <div className="flex gap-4 mb-4">
                            <Button
                                variant={scanTarget === "reader" ? "default" : "outline"}
                                onClick={() => handleChangeScanTarget("reader")}
                                className="flex-1"
                            >
                                <User className="mr-2 h-4 w-4" />
                                {scanMode === "barcode" ? t('scan_reader_card') : t('enter_reader_id')}
                            </Button>
                            <Button
                                variant={scanTarget === "book" ? "default" : "outline"}
                                onClick={() => handleChangeScanTarget("book")}
                                className="flex-1"
                                disabled={!borrower}
                            >
                                <Book className="mr-2 h-4 w-4" />
                                {scanMode === "barcode" ? t('scan_book') : t('enter_book_barcode')}
                            </Button>
                        </div>
                        {loading && (<div className="border-2 border-dashed rounded-lg p-6 bg-muted flex flex-col items-center justify-center">
                            <div className="flex flex-col items-center gap-2">
                                <Loader2 className="h-8 w-8 animate-spin text-primary" />
                                <p>正在借閱...</p>
                            </div>
                        </div>)}

                        <div className="grid gap-4">
                            <div className="space-y-2">
                                <Label htmlFor="manual-code">{scanTarget === "reader" ? t('reader_id') : t('book_barcode')}</Label>
                                <Input
                                    id="manual-code"
                                    placeholder={scanTarget === "reader" ? t('please_scan_reader_id') : t('please_scan_book_barcode')}
                                    value={manualCode}
                                    onChange={(e) => setManualCode(e.target.value)}
                                    autoFocus
                                    onKeyDown={(e) => {
                                        handleSimulateScan(e)
                                    }}
                                    ref={ref}
                                />
                            </div>
                            {scanMode === "manual" &&
                                <Row>
                                    <Col span={24}>
                                        <Row gutter={[8, 8]}>
                                            <Col
                                                xxl={scanTarget === "reader" ? 20 : 24}
                                                xl={scanTarget === "reader" ? 20 : 24}
                                                lg={scanTarget === "reader" ? 20 : 24}
                                                md={scanTarget === "reader" ? 18 : 24}
                                                sm={scanTarget === "reader" ? 16 : 24}
                                                xs={24}
                                            >
                                                <Button
                                                    block={true}
                                                    onClick={() => handleSimulateScan({ key: "Enter" })}
                                                    disabled={isScanning || !manualCode} className="w-full">
                                                    {isScanning ? (
                                                        <>
                                                            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                                            {t('processing')}
                                                        </>
                                                    ) : scanTarget === "reader" ? (
                                                        t('query_reader')
                                                    ) : (
                                                        t('add_book')
                                                    )}
                                                </Button>
                                            </Col>
                                            {scanTarget === "reader" && <Col xxl={4} xl={4} lg={4} md={6} sm={8} xs={24}>
                                                <Button
                                                    block={true}
                                                    onClick={() => { setSearchStaffModalOpen(true) }}
                                                    className="  bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
                                                >
                                                    {t("reader_card_query")}
                                                </Button>
                                            </Col>}
                                        </Row>
                                    </Col>
                                </Row>
                            }
                        </div>
                    </Col>
                    <Col xl={16} lg={16} md={24} sm={24} xs={24} >
                        {borrower && (
                            <div className="mb-6 p-4 border rounded-lg">
                                <div className="flex items-center gap-2 mb-2">
                                    <User className="h-5 w-5 text-primary text-lg" />
                                    <h3 className="text-lg font-medium">{t('scanned_reader')} </h3>
                                    <StaffPatronModal
                                        propsForm={staff_form}
                                        propsOpen={open}
                                        propsSetOpen={setOpen}
                                    />
                                    <Button
                                        type="link"
                                        loading={staffLoading}
                                        onClick={() => {
                                            setStaffLoading(true)
                                            StaffPatronController.getData({
                                                user_id: borrower?.user_id
                                            })
                                                .then((response) => {
                                                    let data = response?.data || []
                                                    staff_form.resetFields()
                                                    let formValues = data
                                                    staff_form.setFieldsValue({ 'recordset': formValues })
                                                    setOpen(true)
                                                })
                                                .finally(() => {
                                                    setStaffLoading(false)
                                                })
                                        }}>
                                        <Edit2 size={14} />
                                    </Button>
                                </div>
                                <div className="flex justify-between items-center">
                                    <div>
                                        <p className="text-lg font-medium">{borrower?.surname}</p>
                                        <p className="text-md text-muted-foreground">{t('reader_card_number')}: {borrower?.cardnumber}</p>
                                        <p className="text-md text-muted-foreground">{t('reader_branch')}: {borrower?.branchcode}  {borrower?.branchname}</p>
                                        <p className="text-md text-muted-foreground">{t('reader_category')}: {borrower?.categoryname}</p>
                                        <p className="text-md text-muted-foreground">{'證號期限'}: {borrower?.dateexpiry} {dayjs(borrower?.dateexpiry).isBefore(dayjs().startOf('day')) ? <Badge variant="outline" className="bg-red-50 text-red-700 border-red-200">已過期</Badge> : <Badge variant="outline" className="bg-amber-50 text-amber-700 border-amber-200">可借閱</Badge>}  </p>
                                        <p className="text-md text-muted-foreground">{'單位資訊'}:
                                            {borrower?.user_department_role_data && borrower?.user_department_role_data?.map((item) => (<>
                                                <Tag color="geekblue">
                                                    {
                                                        item?.role_name_language_data?.[0]?.language_culture_value ?? ''
                                                    }
                                                    {item?.user_role_department_data && <>
                                                        －
                                                        {item?.user_role_department_data?.map(itemItem => itemItem?.department_language_data?.[0]?.language_culture_value ?? '').join('、')}
                                                    </>}
                                                </Tag>

                                            </>))}
                                        </p>
                                    </div>
                                    <div>
                                        <Button
                                            variant="ghost"
                                            size="sm"
                                            onClick={() => {
                                                handleClean()
                                            }}
                                        >
                                            {t('change_reader')}
                                        </Button>
                                    </div>

                                </div>
                            </div>
                        )}

                        {scannedBooks.length > 0 && (
                            <div className="space-y-4">
                                <div className="flex items-center justify-between">
                                    <h3 className="font-medium">已掃描書籍 ({scannedBooks.length})</h3>
                                    <Badge variant="outline">{scannedBooks.length} 本書籍</Badge>
                                </div>

                                {/* <ScrollArea className="h-[300px] rounded-md border"> */}
                                <div className="p-4 space-y-4 ">
                                    {scannedBooks?.map((book) => (
                                        <div key={book?.item_itemnumber}
                                            className={`flex items-center justify-between border-b pb-3 ${book?.borrow_result === "success" && "bg-green-50/70 p-2 border border-green-100"} ${book?.borrow_result === "error" && "bg-red-50/70 p-2 border border-red-100"}`}>

                                            <div className="flex items-center gap-1">
                                                <div className="relative h-[60px] w-[40px] overflow-hidden rounded-md border bg-muted">
                                                    <img
                                                        src={`https://media.taaze.tw/showLargeImageByIsbn.ashx?height=100%&isbn=${book?.bibitem_isbn}`}
                                                        alt={book?.bib_title}
                                                        className="object-cover h-full w-full"
                                                    />
                                                </div>

                                                <div >
                                                    <div>
                                                        <h4 className="font-medium text-lg">{book?.bib_title}{book?.bib_subtitle}  {getBookStatusBadge(book?.issue_cancheckout ? 'available' : "not_for_loan")}</h4>
                                                    </div>
                                                    <div className="flex items-center justify-between m-3" >
                                                        <div className=" mr-2">
                                                            <p className="text-md text-muted-foreground">{t('item_number')}:{book?.item_barcode} </p>
                                                            <p className="text-md text-muted-foreground">{t('isbn')}: {book?.bibitem_isbn} </p>
                                                        </div>
                                                        <div className="  mr-2">
                                                            <p className="text-md text-muted-foreground">{t('due_date')}: {book?.due_date} </p>
                                                            <p className="text-md text-muted-foreground text-[#1976d2]">{t('note')}: {book?.item_internal_notes} </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <Typography.Title
                                                    className={`font-medium ${book?.borrow_result === "success" && "text-green-700 border-green-200"}${book?.borrow_result === "error" && "text-red-700 border-red-200"}`}>
                                                    {book?.borrow_result === "success" && "借閱成功"}{book?.borrow_result === "error" && "借閱失敗"}
                                                </Typography.Title>
                                            </div>
                                            <div>
                                                <div>
                                                    {!!book?.checkout_id && book?.borrow_result === "success" && <Button
                                                        variant="ghost"
                                                        size="icon"
                                                        onClick={() => {
                                                            setModalOpen(true)
                                                            form.setFieldsValue({
                                                                issue_id: book?.checkout_id,
                                                                note: book?.note
                                                            })
                                                        }}
                                                        className="h-8 w-8 text-[#1976d2]"
                                                    >
                                                        <Edit className="h-4 w-4 " />  修改備注
                                                    </Button>}
                                                </div>
                                                <div>
                                                    <Button
                                                        variant="ghost"
                                                        size="icon"
                                                        onClick={() => handleRemoveBook(book?.item_itemnumber)}
                                                        className="h-8 w-8 text-destructive"
                                                    >
                                                        <Trash2 className="h-4 w-4" /> 刪除
                                                    </Button>
                                                </div>
                                            </div>

                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </Col>
                    <Col xl={8} lg={8} md={24} sm={24} xs={24}>
                        {borrower?.borrowernumber && <div>
                            <Typography.Title level={4}>讀者尚未歸還紀錄</Typography.Title>
                            <BorrowedBooks
                                keyPrefix={keyPrefix}
                                borrowernumber={borrower?.borrowernumber}
                                enableBorrowTimeSorting={true}
                                showCard={{
                                    xxl: 1,
                                    xl: 1,
                                    lg: 1,
                                    md: 2,
                                    sm: 2,
                                    xs: 1,
                                }}
                            />
                        </div>}
                    </Col>
                </Row>

            </div>
        </Col>
    </Row >)
}

const Borrow = (props) => {
    const keyPrefix = props?.keyPrefix || "library.backstage.borrow"
    const { t } = useTranslation('translation', { keyPrefix })
    const [todayBorrowBooks, setTodayBorrowBooks] = useState([])
    const [todayReturnBooks, setTodayReturnBooks] = useState([])
    const [todayBorrowLoading, setTodayBorrowLoading] = useState(false)
    const [todayReturnLoading, setTodayReturnLoading] = useState(false)

    const TodayBorrowController = useCRUDController({
        apiRoute: "/library/koha/checkout",
    })
    const TodayBorrowHistoryController = useCRUDController({
        apiRoute: "/koha/checkout/history",
    })
    const TodayReturnController = useCRUDController({
        apiRoute: "/koha/checkout/history",
    })

    const sortByDateDesc = (records, dateKey) => {
        return records.sort((a, b) => dayjs(b?.[dateKey]).valueOf() - dayjs(a?.[dateKey]).valueOf())
    }

    const mergeTodayBorrowRecords = (activeRecords, historyRecords) => {
        const recordMap = new Map();
        [...activeRecords, ...historyRecords].forEach((record) => {
            const key = record?.issue_id || `${record?.item_itemnumber}-${record?.issue_issuedate}`;
            if (key) recordMap.set(key, record);
        })

        return sortByDateDesc(Array.from(recordMap.values()), "issue_issuedate")
    }

    const loadTodayBorrows = () => {
        const today = dayjs().format('YYYY-MM-DD')
        setTodayBorrowLoading(true)
        return Promise.all([
            TodayBorrowController.getData({
                date_issue_start: today,
                date_issue_end: today,
                cur_page: 1,
                size: 1000
            }),
            TodayBorrowHistoryController.getData({
                date_issue_start: today,
                date_issue_end: today,
                cur_page: 1,
                size: 1000
            })
        ]).then(([activeResponse, historyResponse]) => {
            setTodayBorrowBooks(mergeTodayBorrowRecords(activeResponse?.data || [], historyResponse?.data || []))
        }).catch(() => {
            message.error(t('load_today_borrows_failed'))
        }).finally(() => {
            setTodayBorrowLoading(false)
        })
    }

    const loadTodayReturns = () => {
        const today = dayjs().format('YYYY-MM-DD')
        setTodayReturnLoading(true)
        return TodayReturnController.getData({
            date_return_start: today,
            date_return_end: today,
            cur_page: 1,
            size: 1000
        }).then((response) => {
            const todayReturns = (response?.data || [])
                .filter((book) => !!book?.issue_returndate)
            setTodayReturnBooks(sortByDateDesc(todayReturns, "issue_returndate"))
        }).catch(() => {
            message.error(t('load_today_returns_failed'))
        }).finally(() => {
            setTodayReturnLoading(false)
        })
    }

    const loadTodayRecords = () => {
        loadTodayBorrows()
        loadTodayReturns()
    }

    useEffect(() => {
        loadTodayRecords()
        // 今日紀錄只在頁面首次載入時讀取；切換 tab 不重新讀取，需按重新整理。
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <Tabs
        defaultActiveKey="borrow"
        fill={true}
        items={[
            {
                key: "borrow",
                tab: t('borrow_tab'),
                content: <BorrowWorkflow {...props} />
            },
            {
                key: "today_borrow",
                tab: t('today_borrow_tab'),
                content: <TodayCirculationRecords
                    type="borrow"
                    records={todayBorrowBooks}
                    loading={todayBorrowLoading}
                    onRefresh={loadTodayBorrows}
                    keyPrefix={keyPrefix}
                />
            },
            {
                key: "today_return",
                tab: t('today_return_tab'),
                content: <TodayCirculationRecords
                    type="return"
                    records={todayReturnBooks}
                    loading={todayReturnLoading}
                    onRefresh={loadTodayReturns}
                    keyPrefix={keyPrefix}
                />
            }
        ]}
    />
}

const TodayCirculationRecords = ({
    type = "borrow",
    records = [],
    loading = false,
    onRefresh = () => { },
    keyPrefix = "library.backstage.borrow",
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const isBorrow = type === "borrow"
    const [sortDirection, setSortDirection] = useState("desc")

    const getTime = (record) => {
        const value = isBorrow ? record?.issue_issuedate : record?.issue_returndate
        return value ? dayjs(value).format("HH:mm") : "-"
    }

    const dateKey = isBorrow ? "issue_issuedate" : "issue_returndate"
    const sortedRecords = [...records].sort((a, b) => {
        const timeA = dayjs(a?.[dateKey]).valueOf()
        const timeB = dayjs(b?.[dateKey]).valueOf()
        return sortDirection === "asc" ? timeA - timeB : timeB - timeA
    })

    return (
        <Card>
            <CardHeader>
                <div className="flex items-center justify-between gap-3">
                    <div>
                        <CardTitle className="flex items-center gap-2">
                            <CalendarDays className="h-5 w-5" />
                            {isBorrow ? t('today_borrow_records') : t('today_return_records')}
                        </CardTitle>
                        <CardDescription>
                            {loading
                                ? (isBorrow ? t('loading_today_borrows') : t('loading_today_returns'))
                                : (isBorrow ? t('borrowed_today', { count: records.length }) : t('returned_today', { count: records.length }))}
                        </CardDescription>
                    </div>
                    <div className="flex items-center gap-2">
                        <Button
                            type="button"
                            variant="outline"
                            onClick={() => setSortDirection((current) => current === "asc" ? "desc" : "asc")}
                        >
                            {sortDirection === "asc"
                                ? <ArrowUp className="mr-2 h-4 w-4" />
                                : <ArrowDown className="mr-2 h-4 w-4" />}
                            {t(sortDirection === "asc" ? 'borrow_time_oldest_first' : 'borrow_time_newest_first')}
                        </Button>
                        <Button
                            type="button"
                            loading={loading}
                            disabled={loading}
                            onClick={onRefresh}
                        >
                            <RefreshCw className="mr-2 h-4 w-4" />
                            {t('refresh')}
                        </Button>
                    </div>
                </div>
            </CardHeader>
            <CardContent>
                <div className="h-[calc(100vh-14rem)] overflow-y-auto pr-2">
                    {records.length > 0 ? (
                        <Table>
                            <TableHeader>
                                <TableRow>
                                    <TableHead>{t('title')}</TableHead>
                                    <TableHead>{t('borrower')}</TableHead>
                                    <TableHead>{t('time')}</TableHead>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {sortedRecords.map((record) => (
                                    <TableRow key={`${record?.issue_id || record?.item_itemnumber}-${isBorrow ? record?.issue_issuedate : record?.issue_returndate}`}>
                                        <TableCell>
                                            <div className="font-medium">{record?.bib_title}{record?.bib_subtitle}</div>
                                            <div className="text-md text-muted-foreground">{t('barcode')}: {record?.item_barcode}</div>
                                            <div className="text-md text-muted-foreground">{t('note')}: {record?.issue_note}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div>{record?.staff_name || record?.issue_borrower_surname || "-"}</div>
                                            <div className="text-md text-muted-foreground">{record?.issue_borrower_cardnumber}</div>
                                        </TableCell>
                                        <TableCell>
                                            {getTime(record)}
                                            {!isBorrow && <Button
                                                block={true}
                                                variant="link"
                                                className="text-blue-600 hover:text-blue-800 p-0 h-auto"
                                                onClick={() => {
                                                    window.open(`./borrow?cardnumber=${record?.issue_borrower_cardnumber}`, 'blank')
                                                }}>
                                                {t('go_to_borrow')}
                                            </Button>}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    ) : (
                        <div className="flex items-center justify-center h-40 text-muted-foreground">
                            {isBorrow ? t('no_borrow_records') : t('no_return_records')}
                        </div>
                    )}
                </div>
            </CardContent>
        </Card>
    )
}

export default Borrow
